export function hoursToHoursMinutes(hours) {
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return {hours: h, minutes: m};
}

export const getFormattedTime = time => {
  const {hours, minutes} = hoursToHoursMinutes(time);

  const parts = [];
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes}m`);

  return parts.join(' ') || '0m';
};
